module.exports = __webpack_public_path__ + "static/media/handoffEmpty@2x.f41ee12b.png";